<template>
  <el-container direction="vertical">
    <router-view name="header"></router-view>
    <router-view name="trdpage"></router-view>
    <!--    trdpage 用于前端交互页面-->
    <el-main class="app-main" ref="main">
      <router-view name="sidebar"></router-view>
      <router-view></router-view>
    </el-main>
    <!--    sidebar 和default 用于后台维护页面-->
    <router-view name="footer"></router-view>
    <svg-icon style="display: none"></svg-icon>
  </el-container>
</template>

<script>
  import svgIcon from './components/common/svg'
  import {getLocalStore, getSessionStore, removeLocalStore} from './services/utils/mUtils';
  export default {
    name: 'App',
    created() {
      if (getLocalStore('state')) {
        this.$store.replaceState( Object.assign( {}, this.$store.state, JSON.parse(getLocalStore('state') ) ) )
      }
      // 页面刷新时将state数据存储到sessionStorage中
      // window.addEventListener('beforeunload',()=>{

        // removeLocalStore('state')
        // this.$store.commit('SET_TOKEN', '')
        // this.$store.commit('SET_USERINFO', '')
        // this.$store.commit('SET_ACCOUNT', '')
        // this.$store.commit('SET_PERMISSION', '')
        // this.$store.commit('SET_SHPINFO', '')
        // this.$router.push({name: 'login'})
        // console.log('beforeunload',this.$store.state)
        // setLocalStore('state',JSON.stringify(this.$store.state))
      // })

    },

    components: {
      svgIcon
    }
  }
</script>

<style lang="scss">
  @import './style/common';
  @import './style/mixin';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
    position: relative;
    min-height: 900px;
    min-width: 900px;
    background: $bgc;
  }
  .app-main {
    /*padding: 0 20px;*/
    width: 1190px !important;
  }
  .el-main {
    @include wh(100%, 100%);
    margin: 0 auto;
    padding: 0 !important;
  }
  /*.footer {*/
  /*  position: absolute;*/
  /*  bottom: 0;*/
  /*  width: 100%;*/
  /*}*/
  .el-message {
    left: 30%;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  .main-container {
    .el-main {
      @include wh($mainw, 100%);
      margin-top: 20px;
      text-align: left;
    }
    .el-footer {
      @include wh($mainw, 100%);
      margin: 20px auto 0;
      padding: 0px;
      text-align: right;
    }
    .el-breadcrumb {
      @include wh($mainw, 28px);
      line-height: 28px;
      margin: 0 auto;
    }
  }
  .mainw {
    width: $mainw;
    margin: 0 auto;
  }
</style>
